// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_jh-5";
export var filledCircle = "_jh-4";
export var historyEntry = "_jh-3";
export var messageSideLeft = "_jh-1";
export var messageSideRight = "_jh-2";
export var orderTrackingCarouselWrapper = "_jh-6";
export var orderTrackingInfoContainer = "_jh-0";